import addError from '../../../utils/error.jsx';
import { bulk } from './update';

export function request(sportId, list) {
    return {
        type: 'MARKET_TEMPLATES_MOVE_REQUEST',
        sportId,
        list
    };
}

export function error(errors) {
    addError(errors);

    return {
        type: 'MARKET_TEMPLATES_MOVE_ERROR',
        errors
    };
}

export function finish(marketTemplates) {
    return (dispatch) => {
        dispatch(bulk(marketTemplates));

        dispatch({
            type: 'MARKET_TEMPLATES_MOVE_FINISH',
            marketTemplates
        });
    };
}

export function clear() {
    return {
        type: 'MARKET_TEMPLATES_MOVE_CLEAR'
    };
}
